import React from 'react'
import cx from 'classnames'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined'
import { Theme } from '@mui/material'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    displayNone: {
      display: 'none',
    },
  })
)

interface Props {
  checked: boolean
}

export const CheckIconOnly: React.FC<Props> = ({ checked }) => {
  const classes = useStyles()
  return (
    <>
      <CheckOutlinedIcon className={cx(checked || classes.displayNone)} />
      <ClearOutlinedIcon className={cx(checked && classes.displayNone)} color="secondary" />
    </>
  )
}

export const CheckIcon: React.FC<Props> = ({ checked }) => {
  const classes = useStyles()
  return (
    <>
      <span className={cx(checked || classes.displayNone)}>
        <CheckOutlinedIcon />
      </span>
      <span className={cx(checked && classes.displayNone)}>
        <ClearOutlinedIcon color="secondary" />
      </span>
    </>
  )
}
